export var AdvancedSettingCategory = /*#__PURE__*/ function(AdvancedSettingCategory) {
    AdvancedSettingCategory["Pricing"] = "Pricing";
    AdvancedSettingCategory["Billing"] = "Billing";
    AdvancedSettingCategory["Integrations"] = "Integrations";
    return AdvancedSettingCategory;
}({});
export var AdvancedSetting = /*#__PURE__*/ function(AdvancedSetting) {
    AdvancedSetting["Pause"] = "pause";
    AdvancedSetting["BillOnApproval"] = "billOnApproval";
    AdvancedSetting["Prorate"] = "prorate";
    AdvancedSetting["Optional"] = "optional";
    AdvancedSetting["LimitCharges"] = "limitCharges";
    AdvancedSetting["AutoPriceIncrease"] = "autoPriceIncrease";
    AdvancedSetting["QboClasses"] = "qboClasses";
    AdvancedSetting["FinancialCents"] = "financialCents";
    AdvancedSetting["Karbon"] = "karbon";
    AdvancedSetting["LimitedTimeDiscountOffer"] = "limitedTimeDiscountOffer";
    AdvancedSetting["LimitedTimeDiscountOfferForAgreement"] = "limitedTimeDiscountOfferForAgreement";
    AdvancedSetting["PreapprovedAmount"] = "preapprovedAmount";
    AdvancedSetting["StartAutomaticBillingAt"] = "startAutomaticBillingAt";
    return AdvancedSetting;
}({});
export var IncreaseMethod = /*#__PURE__*/ function(IncreaseMethod) {
    IncreaseMethod["EffectiveDate"] = "effectiveDate";
    IncreaseMethod["Date"] = "date";
    return IncreaseMethod;
}({});
export const ADVANCED_SETTING_CATEGORY_MAP = {
    ["limitedTimeDiscountOffer"]: "Pricing",
    ["limitedTimeDiscountOfferForAgreement"]: "Pricing",
    ["autoPriceIncrease"]: "Pricing",
    ["startAutomaticBillingAt"]: "Billing",
    ["limitCharges"]: "Billing",
    ["preapprovedAmount"]: "Billing",
    ["optional"]: "Billing",
    ["billOnApproval"]: "Billing",
    ["prorate"]: "Billing",
    ["pause"]: "Billing",
    ["qboClasses"]: "Integrations",
    ["financialCents"]: "Integrations",
    ["karbon"]: "Integrations"
};
